import styled from 'styled-components';
import { colorTextPlaceholder } from '@atlas-frontend/design-tokens';

export const TextPlaceholder = styled.span`
  color: ${colorTextPlaceholder};
`;
